import React from "react"

import {
  FaFacebook,
  FaTwitter,
  FaYoutube,
  FaTelegram,
  FaInstagram,
  FaDiscord,
  FaMedium,
  FaLinkedin,
  FaPodcast,
} from "react-icons/fa"
import IconLink from "../../IconLink/IconLink"

import * as styles from "./SocialIcons.module.css"
import config from "../../../config"
import { Icon } from "semantic-ui-react"
import { Link } from "gatsby"

const SocialIcons: React.FC<{
  client?: string,
  themeColor?: string,
}> = ({
  client='season1',
  themeColor=(client && config[client].themeColor),
}) => {
  if (config === undefined) return undefined;
  return (
    <span className={styles.container} style={{color: themeColor}}>
      {
        config[client].social.twitter &&
        <Link target="_blank" to={config[client].social.twitter}>
          <Icon
            name="twitter"
          />
        </Link>
      }
      {
        config[client].social.insta &&
        <Link target="_blank" to={config[client].social.insta}>
          <Icon
            name="instagram"
          />
        </Link>
      }
      {
        config[client].social.facebook &&
        <Link target="_blank" to={config[client].social.insta}>
          <Icon
            name="facebook"
          />
        </Link>
      }
      {/* {
        config[client].social.youtube &&
        <IconLink
          icon={FaYoutube}
          to={config[client].social.youtube}
          externalLink={true}
        />
      }
      {
        config[client].social.facebook &&
        <IconLink
          icon={FaFacebook}
          to={config[client].social.facebook}
          externalLink={true}
        />
      }
      {
        config[client].social.instagram &&
        <IconLink
          icon={FaInstagram}
          to={>social.instagram}
          externalLink={true}
        />
      } */}
    </span>
  )
}

export default SocialIcons
